import {
  ADD_DOCS,
  ADD_TOKEN__INFO,
  DO_LOGOUT,
  RESET_TOKENS,
  SET_DOCS,
  START_TIMER,
} from "./actions";

const initialState = {
  tokens: {
    isAlumni:false,
    showToast:false,
    defaultDob:false,
    token: "",
    refreshToken: "",
    userId: "",
    appId: "",
    salesForceUserId: "",
    applicationData: {},
    personalId: "",
    showBank:true,
    showSpoc:true,
    applicationStatus: "Registered",
    registrationData: {},
    docs: {},
    caseDocs: {},
    showFeedback: false,
    showImpact: false,
    totalLoginResponse: {},
    startTime: "",
    duration: 0,
    personalData:{},
    incomeData:{},
    eduData:{},
    isDropout:false,
    showDropout:false,

  },
};

const tokenReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TOKEN__INFO:
      let data = state.tokens;
      data[action.data[0]] = action.data[1];
      return {
        ...state,
        tokens: { ...data },
      };
    case START_TIMER:
      let data5 = state.tokens;
      const currentTime = new Date();
      const hours = currentTime.getHours().toString().padStart(2, "0");
      const minutes = currentTime.getMinutes().toString().padStart(2, "0");
      const seconds = currentTime.getSeconds().toString().padStart(2, "0");
      const formattedTime = `${hours}:${minutes}:${seconds}`;
      data5["startTime"] = formattedTime;
      return {
        ...state,
        tokens: { ...data5 },
        // startTime: Date.now(),
      };
    case ADD_DOCS:
      let data3 = state.caseDocs;
      data3 = { ...action.data };
      return {
        ...state,
        caseDocs: { ...data3 },
      };
    case DO_LOGOUT:
      // let data2 = state.tokens;
      // data2.token = "";
      // data2.refreshToken = "";
      return initialState;
      // return {
      //   ...state,
      //   tokens: { ...data2 },
      // };
    case RESET_TOKENS:
      return initialState;
    default:
      return state;
  }
};
export default tokenReducer;
